
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { showModal } from "../../features/modal/modalSlice"
import Button from "../shared/Button"
import { resetStatusCode } from "../../features/admin/adminSlice"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { useEffect } from "react"
import ResultSuccessTickMark from "../shared/ResultSuccessTickMark"
import ResultErrorXMark from "../shared/ResultErrorXMark"
import { useScrollLock } from "../../hooks/useScrollLock"
import Btn from "../shared/button/Btn"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: 600px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        p{
            font-size: 16px;
            font-weight: var(--font-weight-md);
            color: ${({ theme }) => theme.mainTextColor};
            padding: 30px 0;
        }

        .link{
            background-color: #E85446;
            color: #fff;
            width: 310px;
            border-radius: 10px;
            width: ${({width})=> width};
            padding: 12px;
            text-align: center;
            font-size: 16px;
            line-height: 1;
            font-weight: var(--font-weight-md);
        }

    }
`
const ResultModal = () => {
    const {resultModalData, modalLocation} = useSelector(state => state.modal)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const { lockScroll, unlockScroll } = useScrollLock();
    useEffect(() => {
        const timer = setTimeout(() => {
            if(resultModalData?.resultType === "success"){
                dispatch(showModal(false));
                if(resultModalData?.routePath){
                    navigate(resultModalData?.routePath)
                }
            }
        }, 1500);
        return () => clearTimeout(timer);
      }, [resultModalData?.resultType]);

         //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])


    if(!resultModalData){
        return null
    }

    //! belki burada api den gelen olumlu ya da olumsuz cevaba göre farklı components lar render edilebilir.( belki bu sayede şu gıcık svg renk değiştirme sorunu çözülür.) ***********************************************************
    
  return (
    <Container onClick={()=> showModal(null)}>
        <div className="modal" onClick={(e)=> e.stopPropagation()}>
            {
                resultModalData.resultType === "success"?
                <ResultSuccessTickMark/>:
                <ResultErrorXMark/>
            }
            <p>{resultModalData.msg}</p>
            {
                resultModalData.routePath ? 
                <Link to={resultModalData.routePath} className="link" onClick={() => dispatch(showModal(null))}>{resultModalData.btnText1}</Link>:
                <Btn handleClick={()=> {dispatch(showModal(null)); dispatch(resetStatusCode())}} bgColor="#E85546" color="#fff" width={"350px"}>Geri Dön</Btn>
            }
        </div>
    </Container>
  )
}

export default ResultModal